// AUTO GENERATED FILE BY @kalissaac/prisma-typegen
// DO NOT EDIT


export enum GroupRole {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
}

export enum Score {
  VERY_BAD = "VERY_BAD",
  BAD = "BAD",
  GOOD = "GOOD",
  VERY_GOOD = "VERY_GOOD",
}

export enum Right {
  READ = "READ",
  WRITE = "WRITE",
  ALL = "ALL",
}

export enum EvaluationStatus {
  DRAFT = "DRAFT",
  PUBLIC = "PUBLIC",
}


export interface User {
  id: string;
  email: string;
  password: string;
  firstName: string;
  lastName?: string;
  street?: string;
  houseNumber?: string;
  city?: string;
  zipCode?: string;
  country: string;
  groups: GroupUser[];
  evaluations: EvaluationRelation[];
  ownedEvaluations: EvaluationRight[];
  language: string;
  isAdmin: boolean;
  createdAt: Date;
  updatedAt: Date;
  resetString?: string;
  resetTime?: Date;
  evaluator: UserRelation[];
  evaluated: UserRelation[];
  evaluatorInv: UserRelationInvitation[];
  evaluatedInv: EvaluatorRelationInvitation[];
  disabled: boolean;
}

export interface UserRelationInvitation {
  id: string;
  evaluatorId: string;
  evaluator: User;
  email: string;
  sentAt: Date;
  randomString: string;
  public: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface EvaluatorRelationInvitation {
  id: string;
  evaluatedId: string;
  evaluated: User;
  email?: string;
  sentAt: Date;
  randomString: string;
  public: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface Group {
  id: string;
  name: string;
  users: GroupUser[];
  masters: GroupRelation[];
  childs: GroupRelation[];
  evaluations: EvaluationRelation[];
  invitationGroups: InvitationGroup[];
  until?: Date;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
  urlInvitation: urlInvitationGroup[];
}

export interface GroupRelation {
  id: string;
  master: Group;
  masterId: string;
  child: Group;
  childId: string;
  until?: Date;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface GroupUser {
  id: string;
  groupId: string;
  userId: string;
  group: Group;
  user: User;
  until?: Date;
  role: GroupRole;
  active: boolean;
  createdAt: Date;
  updatedAt: Date;
  GroupUserRole: GroupUserRole[];
}

export interface UserRelation {
  id: string;
  evaluatorId: string;
  evaluator: User;
  evaluatedId: string;
  evaluated: User;
  until: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface GroupUserRole {
  id: string;
  role: string;
  groupUserId: string;
  groupUser: GroupUser;
  createdAt: Date;
  updatedAt: Date;
}

export interface InvitationGroup {
  id: string;
  groupId: string;
  group: Group;
  isActive: boolean;
  email?: string;
  sentAt: Date;
  randomString: string;
  public: boolean;
  expireDate: Date;
  createdAt: Date;
  updatedAt?: Date;
}

export interface urlInvitationGroup {
  id: string;
  groupId: string;
  group: Group;
  randomString: string;
  public: boolean;
  expireDate: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface InvitationUser {
  id: string;
  evaluationId: string;
  evaluation: Evaluation;
  randomString: string;
  expireDate: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface Indicator {
  id: string | undefined;
  name: string;
  masterId?: string;
  master?: Indicator;
  childs: Indicator[];
  observations?: Observation[];
  translations: Translation[];
  createdAt: Date;
  updatedAt: Date;
}


export interface Observation {
  id: string;
  observation: string;
  indicatorId: string;
  indicator: Indicator;
  levels: Level[];
  createdAt: Date;
  updatedAt: Date;
}

export interface Level {
  id?: string;
  observationId?: string;
  observation?: Observation;
  score: Score;
  text: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface Skill {
  id: string | undefined;
  name: string;
  masterId?: string;
  master?: Skill;
  childs: Skill[];
  translations: Translation[];
  createdAt: Date;
  updatedAt: Date;
}

export interface EvaluationIndicator {
  id: string;
  evaluationId: string;
  evaluation: Evaluation;
  indicatorId: string;
  indicator: Indicator;
  createdAt: Date;
  updatedAt: Date;
}

export interface EvaluationRelationScore {
  id: string;
  evaluationRelations: EvaluationRelation[];
  scores: EvaluationRelationScores[];
  createdAt: Date;
  updatedAt: Date;
}

export interface EvaluationRelationScores {
  id?: string;
  evaluationRelationScoreId?: string;
  evaluationRelationScore?: EvaluationRelationScore;
  percentage: number;
  comment?: string;
  indicatorId: string;
  indicator: Indicator;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface Evaluation {
  id: string;
  evaluation: string;
  indicators: EvaluationIndicator[];
  evaluated: EvaluationRelation[];
  rights: EvaluationRight[];
  status: EvaluationStatus;
  createdAt: Date;
  updatedAt: Date;
  InvitationUser: InvitationUser[];
}


export interface EvaluationRight {
  id: string;
  evaluationId: string;
  evaluation: Evaluation;
  userId?: string;
  user?: User;
  rights: Right;
  createdAt: Date;
  updatedAt: Date;
}

export interface EvaluationRelation {
  id?: string;
  userId?: string;
  user?: User;
  groupId?: string;
  group?: Group;
  evaluation?: Evaluation;
  evaluationId?: string;
  score?: EvaluationRelationScore;
  scoreId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Language {
  id: string;
  name: string;
  native: string;
  code: string;
  translations: Translation[];
}

export interface Translation {
  id: string;
  translation: string;
  languageId: string;
  language: Language;
  skill?: Skill;
  skillId?: string;
  indicator?: Indicator;
  indicatorId?: string;
  createdAt: Date;
  updatedAt: Date;
}




export interface EvaluationToEvaluate {
  id:         number;
  evaluation: string;
  indicators: IndicatorEvaluate[];
  evaluated:  EvaluatedEvaluate[];
}

export interface EvaluatedEvaluate {
  id:    number;
  groupId: string;
  user:  UserEvaluate;
  score: EvaluatedScore;
}

export interface EvaluatedScore {
  scores: ScoreElement[];
}

export interface ScoreElement {
  id:          number;
  percentage:  number;
  comment:     string;
  indicatorId: string;
}

export interface UserEvaluate {
  id:        number;
  firstName: string;
  lastName:  string;
}

export interface IndicatorEvaluate {
  indicatorId: string;
}
